
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("hslOl", function(module, exports) {

$parcel$export(module.exports, "BadgeContainer", () => $79e06360c2294100$export$f710265eb5a003da);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");
const $79e06360c2294100$var$badgeContainerStyles = (0, $3jLHL.css)({
    position: 'absolute',
    insetBlockStart: `${"var(--ds-space-negative-050, -4px)"}`,
    insetInlineEnd: `${"var(--ds-space-negative-025, -2px)"}`,
    pointerEvents: 'none'
});
const $79e06360c2294100$var$containerStyles = (0, $3jLHL.css)({
    position: 'relative'
});
const $79e06360c2294100$export$f710265eb5a003da = (props)=>{
    const { id: badgeId, badge: Badge, children: children, role: role } = props;
    return /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        css: $79e06360c2294100$var$containerStyles,
        role: role
    }, children, /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        css: $79e06360c2294100$var$badgeContainerStyles,
        id: badgeId,
        "aria-hidden": true
    }, /*#__PURE__*/ (0, $3jLHL.jsx)(Badge, null)));
};

});


//# sourceMappingURL=NotificationsComponent.5ece999f.js.map
